import { useHumanInteraction } from './useHumanInteraction';
import { useWidgetAd } from './useWidgetAd';
import { Box } from '@mui/system';
import { useImpressionPixel } from './useImpressionPixel';
import { StickyUntilVisible } from '../StickyUntilVisible';
import { trackAdClick } from './trackAdClick';

type WidgetAdProps = {
  widgetId?: number;
  impressionEnabled?: boolean;
  variant?: 'footer' | 'popup';
};

export const WidgetAd = ({
  widgetId,
  impressionEnabled = true,
  variant = 'footer',
}: WidgetAdProps) => {
  const isHumanInteraction = useHumanInteraction();

  const { adData } = useWidgetAd({
    widgetId,
  });

  useImpressionPixel({
    enabled: !!adData && impressionEnabled,
    pixelUrl: adData?.impression_pixel_url,
  });

  if (!adData) {
    return null;
  }

  const adView = (
    <Box
      component="a"
      data-ad-id={adData.uid}
      href={adData.link_url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(event) => {
        if (
          event.detail === 0 ||
          event.screenX === 0 ||
          event.screenY === 0 ||
          !isHumanInteraction
        ) {
          event.preventDefault();
          return;
        }

        if (adData?.uid) {
          trackAdClick(
            `https://${process.env.NEXT_PUBLIC_CACHE_ENDPOINT}/ads/text/${adData.uid}/link/`
          );
        }
      }}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        textDecoration: 'none',
      }}
    >
      <img
        src={variant === 'popup' ? adData.image_url : adData.second_image_url}
        style={
          variant === 'popup'
            ? {
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                maxHeight: 'calc(100vh - 2rem)',
                maxWidth: '320px',
              }
            : {
                width: '100%',
                height: 'auto',
                objectFit: 'contain',
                maxWidth: '320px',
              }
        }
      />
    </Box>
  );

  if (variant === 'footer') {
    return (
      <StickyUntilVisible
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
        }}
        height={50}
      >
        {adView}
      </StickyUntilVisible>
    );
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        zIndex: 1300,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'start',
        padding: '1rem',
      }}
    >
      {adView}
    </Box>
  );
};
